import * as ReactDOM from 'react-dom/client';
import { WebComponent, UIRuntimeBuilder } from '@cian/mf-registry/browser';

import { Application } from 'shared/containers/App';
import { IApplicationContext } from 'shared/types/applicationContext';
import { TReduxStore } from 'shared/types/redux';
import { MICROFRONTEND_PATH } from 'shared/constants/microfrontend';
import { setSearchMetaTooltipAvailable } from 'shared/slices/searchMetaTooltip';
import { setAdfoxPuids } from 'shared/slices/adfox';
import { TAdfoxPuids } from 'shared/types/adfox';
import { equals } from 'ramda';
import { updateTags } from 'shared/thunks/tags';
import { setJsonQuery } from 'shared/slices/jsonQuery';
import { JsonObject } from 'shared/types/jsonObject';

interface IProps extends JsonObject {
  applyAfterChange: boolean;
  searchMetaTooltipEnabled: boolean;
  regionId: number;
  jsonQuery: JsonObject;
  adfoxPuids: TAdfoxPuids;
}

/* istanbul ignore next */
export const createDesktopFiltersConstructor =
  (context: IApplicationContext, store: TReduxStore) => (): UIRuntimeBuilder => {
    class DesktopFilters extends WebComponent<IProps> {
      public constructor() {
        super();
      }
      private root: ReactDOM.Root;
      protected microfrontendName = context.config.getStrict<string>('projectName');
      protected imageVersion = context.config.getStrict<string>('version.commit');
      protected runtimeName = MICROFRONTEND_PATH.v1;

      public disconnectedCallback() {
        super.disconnectedCallback();
        if (this.root) {
          this.root.unmount();
        }
      }

      public componentDidUpdate(prevProps: IProps): void {
        const { searchMetaTooltipEnabled, adfoxPuids } = this.props;

        if (searchMetaTooltipEnabled !== prevProps.searchMetaTooltipEnabled) {
          store.dispatch(setSearchMetaTooltipAvailable(searchMetaTooltipEnabled));
        }

        if (!equals(adfoxPuids, prevProps.adfoxPuids)) {
          store.dispatch(setAdfoxPuids(adfoxPuids));
        }

        if (!equals(this.props.jsonQuery, prevProps.jsonQuery)) {
          store.dispatch(setJsonQuery(this.props.jsonQuery));
          store.dispatch(updateTags());
        }
      }

      public async render() {
        const reactElement = <Application context={context} reduxStore={store} />;

        if (this.root) {
          this.root.render(reactElement);
        } else {
          this.root = ReactDOM.createRoot(this);
          this.root.render(reactElement);
        }
      }
    }

    return { customElementConstructor: DesktopFilters };
  };
